import { ArrowRight, Compass, Info, MapPinned } from 'lucide-react';
import { rankVisits } from '../domain/aggregators';
import { formatKm } from '../domain/distance';
import type { AnalysisResult } from '../domain/models';

export function AnalysisInterpretation({ result }: { result: AnalysisResult }) {
  const rankedVisits = rankVisits(result.visits, 1);
  const averageDistance = result.dailySummaries.length > 0 ? result.stats.totalDistanceMeters / result.dailySummaries.length : 0;
  const highDistanceDays = [...result.dailySummaries].sort((a, b) => b.distanceMeters - a.distanceMeters).slice(0, 3);
  const topVisit = rankedVisits[0];

  return (
    <section className="surface interpretation">
      <div className="section">
        <div>
          <h2 className="section-title">この結果の読み方</h2>
          <p className="section-note">まずは「距離が大きい日」「長く滞在した場所」「旅行候補」を見ると、データの意味を掴みやすくなります。</p>
        </div>
        <div className="grid three">
          <div className="insight-card">
            <Compass size={18} aria-hidden="true" />
            <strong>全体像</strong>
            <p>
              {result.dailySummaries.length.toLocaleString('ja-JP')} 日分を解析し、1日平均の推定移動距離は {formatKm(averageDistance)} km です。
            </p>
          </div>
          <div className="insight-card">
            <MapPinned size={18} aria-hidden="true" />
            <strong>生活圏</strong>
            <p>
              {topVisit
                ? `最も長く滞在した候補は ${topVisit.placeName ?? `${topVisit.center.lat.toFixed(3)}, ${topVisit.center.lng.toFixed(3)} 周辺`} です。`
                : '滞在候補が少ないため、生活圏の推定は弱めです。'}
            </p>
          </div>
          <div className="insight-card">
            <Info size={18} aria-hidden="true" />
            <strong>推定として読む</strong>
            <p>滞在、移動手段、旅行候補は確定情報ではありません。確度ラベルと元の日付を見ながら確認してください。</p>
          </div>
        </div>
        {highDistanceDays.length > 0 ? (
          <div className="next-actions">
            <strong>次に見る日</strong>
            {highDistanceDays.map((day) => (
              <span key={day.date}>
                <ArrowRight size={14} aria-hidden="true" />
                {day.date}: {formatKm(day.distanceMeters)} km
              </span>
            ))}
          </div>
        ) : null}
      </div>
    </section>
  );
}
